import React from 'react';
import type { CustomArtProps } from './CustomArt.types';
import { Box } from '@withjoy/joykit';

export const CustomArt: React.FC<CustomArtProps> = ({ backgroundImageUrl }) => {
  return (
    <Box
      left="50%"
      width="100%"
      bottom={0}
      height="100%"
      position="absolute"
      transform="translateX(-50%)"
      pointerEvents="none"
    >
      <Box
        width="100%"
        height="100%"
        position="absolute"
        backgroundSize="cover"
        backgroundImage={`url(${backgroundImageUrl})`}
        backgroundRepeat="no-repeat"
        backgroundPosition="center bottom"
      />
    </Box>
  );
};

CustomArt.displayName = 'CustomArt';
